<template>
  <v-container>
    <app-activity-indicator v-if="loading"></app-activity-indicator>
    <v-row v-else class="pr-5">
        <v-row v-if="!product.unlocked">
            <v-col cols="12" md="4">
                <v-card elevation=0>
                    <v-img
                    class="white--text"
                    height="150px"
                    contain
                    src="/images/products/tools-tile1.jpg"
                    >
                    </v-img>
                    <v-card-title class="justify-center">
                    <div>
                        <h3 class="headline text-md-center teal--text mb-0">{{product.cost}}</h3>
                    </div>
                    </v-card-title>
                    <v-card-actions class="justify-center">
                    <v-btn color="teal" dark @click="showAlert">Buy</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" md="8">
                <h1 class="headline">Separation Statement</h1>
                <p>This form is offered as a general tool to assist you in documenting your marriage/relationship history.</p>
                <p>It is general suggestions only. Individual circumstances vary. This form is not provided as legal advice.</p>
                <p>It is not recommended that you use this form as an affidavit to submit to court. Please seek legal advice before using this document and submitting the information you provide to court.</p>
            </v-col>
        </v-row>
        <div v-else class="main-layout">
          <v-app-bar fixed class="toolbar">
            <v-toolbar-title>Separation Statement</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="teal" class="mr-4" dark :loading="isSaving" @click="save">
              Save
            </v-btn>
            <v-btn color="teal" outlined :loading="isExportingPdf" @click="exportPDF">
              Download PDF
            </v-btn>
          </v-app-bar>
          <v-tabs
            v-model="activeTab"
            slider-color="teal"
            id="top">
            <v-tab key="0" ripple>Personal Details</v-tab>
            <v-tab key="1" ripple v-show="product.data.formForParenting">Parenting</v-tab>
            <v-tab key="2" ripple v-show="product.data.formForFinancial">Financial</v-tab>
            <v-tab key="3" ripple>General</v-tab>
            <v-tab-item key="0" :transition="false" :reverse-transition="false">
              <v-row>
                <v-col cols="12" sm="8" class="mt-1">
                  <p>This form is offered as a general tool to assist you in documenting your marriage/relationship history. It is general suggestions only. Individual circumstances vary. This form is not provided as legal advice. It is not recommended that you use this form as an affidavit to submit to court. Please seek legal advice before using this document and submitting the information you provide to court.</p>
                </v-col>
              </v-row>
              <v-card class="index-card">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div>Sections</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <div><a href='#top'>Top of page</a></div>
                        <div><a href='#personal-details'>Personal Details</a></div>
                        <div><a href='#relationship-details'>Relationship Details</a></div>
                        <div><b>Children:</b></div>
                        <div><a href='#children'>Children from this marriage</a></div>
                        <div><a href='#children-personA'>Children of Person A</a></div>
                        <div><a href='#children-personB'>Children of Person B</a></div>
                        <div><b>Employment:</b></div>
                        <div><a href='#employment-personA'>Employment of Person A</a></div>
                        <div><a href='#employment-personB'>Employment of Person B</a></div>
                        <div><b>Chores:</b></div>
                        <div><a href='#chores'>Chores</a></div>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
              <v-row>
                <v-col cols="12">
                  <div class="headline">Initial questions for form</div>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12">
                <div>Are you filling this form out for Parenting? <v-switch class="inline" v-model="product.data.formForParenting" :label="`${product.data.formForParenting ? 'Yes' : 'No'}`"></v-switch>
                  <span class="body-2 mt-0 ml-5" v-if="!product.data.formForParenting"><em>You will skip all questions related to Parenting.</em></span>
                </div>
                <div class="mt-2">Are you filling this form out for Financial? <v-switch class="inline" v-model="product.data.formForFinancial" :label="`${product.data.formForFinancial ? 'Yes' : 'No'}`"></v-switch>
                  <span class="body-2 mt-0 ml-5" v-if="!product.data.formForFinancial"><em>You will skip all questions related to Financial.</em></span>
                </div>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col id="personal-details" cols="12">
                  <v-card v-for="(person,index) in product.data.couple" :key="index" class="mb-2">
                    <v-card-title class="pb-0">
                      <div class="headline">{{person.title}}</div>
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-row>
                        <v-col cols="6">
                          <v-text-field v-model="person.name" label="Name"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="person.address" label="Address"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="person.phone" label="Phone"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="person.email" label="Email"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-menu
                            v-model="person.menuDOB"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              label="DOB"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                              :value="person.dob | formatDatePicker"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="person.dob"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="person.age" label="Age"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col id="relationship-details" cols="12">
                  <v-card class="mb-2">
                    <v-card-title class="pb-0">
                      <div class="headline">Relationship details:</div>
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-row>
                        <v-col cols="6">
                          <v-menu
                            v-model="product.dateMetMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              label="Date met"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                              :value="product.data.dateMet | formatDatePicker"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="product.data.dateMet"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                        </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <v-menu
                            v-model="product.dateMovedInMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="product.data.dateMovedIn | formatDatePicker"
                              label="Date moved in together"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="product.data.dateMovedIn"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                        </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-text-field v-model="product.data.address" label="Address lived at"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                              <v-select
                              :items="['Person A rental', 'Person B rental', 'join rental', 'jointly owned', 'Person A\'s asset', 'Person B\'s asset']"
                              v-model="product.data.addressType"
                              label="Address type"
                              class="inline ml-2"
                            ></v-select>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="6">
                          <v-menu
                            v-model="product.dateMarriedMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="product.data.dateMarried | formatDatePicker"
                              label="Date married"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="product.data.dateMarried"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <v-menu
                            v-model="product.dateSeparatedMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="product.data.dateSeparated | formatDatePicker"
                              label="Date separated"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="product.data.dateSeparated"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" id="children">
                  <div class="headline">Children from this marriage/Union</div>
                </v-col>
                <v-col>
                  <v-card v-for="(child,index) in product.data.children" :key="index" class="mb-2">
                    <v-card-title class="pb-0">
                      <div class="headline">Child</div>
                      <v-spacer></v-spacer>
                      <v-btn color="error" outlined @click="product.data.children.splice(index, 1)">Remove</v-btn>
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-row>
                        <v-col cols="6">
                          <v-text-field v-model="child.name" label="Name"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-menu
                            v-model="child.menuDOB"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="child.dob | formatDatePicker"
                              label="DOB"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="child.dob"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field type="number" suffix="%" v-model="child.withParentA" label="Percentage of time living with parent A"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field type="number" suffix="%" v-model="child.withParentB" label="Percentage of time living with parent B"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea v-model="child.comments" label="Other comments"></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-btn dark color="teal" @click="product.data.children.push({})">Add Child +</v-btn>
                </v-col>
                <v-col cols="12" id="children-personA">
                  <div class="headline">Children to person A not from this marriage:</div>
                </v-col>
                <v-col>
                  <v-card v-for="(child,index) in product.data.childrenPersonA" :key="index" class="mb-2">
                    <v-card-title class="pb-0">
                      <div class="headline">Child</div>
                      <v-spacer></v-spacer>
                      <v-btn color="error" outlined @click="product.data.childrenPersonA.splice(index, 1)">Remove</v-btn>
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-row>
                        <v-col cols="6">
                          <v-text-field v-model="child.name" label="Name"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-menu
                            v-model="child.menuDOB"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="child.dob | formatDatePicker"
                              label="Date of birth"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="child.dob"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                        </v-menu>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-btn dark color="teal" @click="product.data.childrenPersonA.push({})">Add Child +</v-btn>
                </v-col>
                <v-col cols="12" id="children-personB">
                  <div class="headline">Children to person B not from this marriage:</div>
                </v-col>
                <v-col>
                  <v-card v-for="(child,index) in product.data.childrenPersonB" :key="index" class="mb-2">
                    <v-card-title class="pb-0">
                      <div class="headline">Child</div>
                      <v-spacer></v-spacer>
                      <v-btn color="error" outlined @click="product.data.childrenPersonB.splice(index, 1)">Remove</v-btn>
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-row>
                        <v-col cols="6">
                          <v-text-field v-model="child.name" label="Name"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-menu
                            v-model="child.menuDOB"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="child.dob | formatDatePicker"
                              label="Date of birth"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="child.dob"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                        </v-menu>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-btn dark color="teal" @click="product.data.childrenPersonB.push({})">Add Child +</v-btn>
                </v-col>
                <v-col cols="12" id="employment-personA">
                  <div class="headline">Person A's employment history (from meeting to now):</div>
                </v-col>
                <v-col>
                  <v-card v-for="(job,index) in product.data.employmentPersonA" :key="index" class="mb-2">
                    <v-card-title class="pb-0">
                      <div class="headline">Job</div>
                      <v-spacer></v-spacer>
                      <v-btn color="error" outlined @click="product.data.employmentPersonA.splice(index, 1)">Remove</v-btn>
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field v-model="job.company" label="Company Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-menu
                            v-model="job.menuStartDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="job.startDate | formatDatePicker"
                              label="Start Date"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="job.startDate"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-menu
                            v-model="job.menuEndDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="job.endDate | formatDatePicker"
                              label="End Date"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="job.endDate"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field v-model="job.description" label="Job Description"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field v-model="job.wage" label="Estimated Yearly Wage"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-btn dark color="teal" @click="product.data.employmentPersonA.push({})">Add Job +</v-btn>
                </v-col>
                <v-col cols="12" id="employment-personB">
                  <div class="headline">Person B's employment history (from meeting to now):</div>
                </v-col>
                <v-col>
                  <v-card v-for="(job,index) in product.data.employmentPersonB" :key="index" class="mb-2">
                    <v-card-title class="pb-0">
                      <div class="headline">Job</div>
                      <v-spacer></v-spacer>
                      <v-btn color="error" outlined @click="product.data.employmentPersonB.splice(index, 1)">Remove</v-btn>
                    </v-card-title>
                    <v-card-text class="pt-0">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field v-model="job.company" label="Company Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-menu
                            v-model="job.menuStartDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="job.startDate | formatDatePicker"
                              label="Start Date"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="job.startDate"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-menu
                            v-model="job.menuEndDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="job.endDate | formatDatePicker"
                              label="End Date"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            v-model="job.endDate"
                            :max="new Date().toISOString().substr(0, 10)"
                            min="1950-01-01"
                          ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field v-model="job.description" label="Job Description"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field v-model="job.wage" label="Estimated Yearly Wage"></v-text-field>
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-btn dark color="teal" @click="product.data.employmentPersonB.push({})">Add Job +</v-btn>
                  <v-divider class="ma-2"></v-divider>
                </v-col>
                <v-col cols="12" id="chores">
                  <div class="headline">Chores:</div>
                  <p>Consider washing, cooking, cleaning, gardening, feeding/bathing/putting kids to bed, school drop off/pick up, homework, etc)</p>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="choresHeaders"
                    :items="product.data.chores"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td>
                            <v-text-field v-if="item.editable" v-model="item.name" type="text"></v-text-field>
                            <span v-else>{{ item.name }}</span></td>
                          <td><v-text-field v-model="item.personA" type="number" suffix="%"></v-text-field></td>
                          <td><v-text-field v-model="item.personB" type="number" suffix="%"></v-text-field></td>
                          <td><v-btn v-if="item.editable" color="error" outlined @click="product.data.chores.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="choresHeaders.length">
                        <v-btn dark color="teal" @click="product.data.chores.push({ name: '', editable: true, personA: 0, personB: 0 })">Add Activity +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="1" :transition="false" :reverse-transition="false">
              <v-card class="index-card">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div>Sections</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <div><a href='#top'>Top of page</a></div>
                        <div><a href='#extended-family-members'>Extended Family Members</a></div>
                        <div><a href='#time-away-from-home'>Time away from home</a></div>
                        <div><a href='#child-support'>Child support</a></div>
                        <div><a href='#parenting-concerns'>Parenting concerns</a></div>
                        <div><a href='#family-dispute'>Family dispute resolution</a></div>
                        <div><a href='#post-separation'>Post separation parenting course</a></div>
                        <div><a href='#parenting-arrangements'>Parenting arrangements</a></div>
                        <div><a href='#proposed-parenting-orders'>Proposed parenting orders</a></div>
                        <div><a href='#expartner-parenting-orders'>Ex-partner parenting orders</a></div>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
              <v-row justify="start">
                <v-col cols="12" id="extended-family-members">
                  <div class="headline">Extended Family Members</div>
                  <p>Add here the relationships of children from the marriage/Union with the extended family</p>
                </v-col>
                <v-col>
                  <v-card v-for="(familyMember,index) in product.data.familyMembers" :key="index" class="mb-2">
                    <v-card-title>
                      <div class="headline">Family Member</div>
                      <v-spacer></v-spacer>
                      <v-btn color="error" outlined @click="product.data.familyMembers.splice(index, 1)">Remove</v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field v-model="familyMember.name" label="Name"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="familyMember.relationship" label="Relationship"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="familyMember.contactFrequency" label="Frequency of contact"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="familyMember.contactType" label="Type of contact"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-textarea v-model="familyMember.comments" label="Other comments"></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-btn dark color="teal" @click="product.data.familyMembers.push({})">Add Family Member +</v-btn>
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col cols="12" id="time-away-from-home">
                  <div class="headline">Time away from home</div>
                  <p>How often and what reason would mother leave the children with the father (eg. hobbies, dinners, elective study, unique work arrangements)</p>
                </v-col>
                <v-col>
                  <v-textarea v-model="product.data.childrenWithFather" label="List all reasons"></v-textarea>
                </v-col>
                <v-col cols="12">
                  <p>How often and what reason would father leave the children with the mother:</p>
                </v-col>
                <v-col>
                  <v-textarea v-model="product.data.childrenWithMother" label="List all reasons"></v-textarea>
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col cols="12" id="child-support">
                  <div class="headline">Child support/ Spousal maintenance</div>
                  <div>Child support is being paid by which Parent?
                    <v-select
                      :items="['Parent A', 'Parent B']"
                      v-model="product.data.childSupportParent"
                      label="Select Parent"
                      class="inline ml-2"
                    ></v-select>
                  </div>
                  <div>The current child support arrangement is: <v-text-field class="inline ml-2" v-model="product.data.childSupportDetails" label="Enter details"></v-text-field></div>
                  <div>The child support is being paid on time: <v-switch class="inline ml-2" v-model="product.data.childSupportPaidOnTime" :label="`${product.data.childSupportPaidOnTime ? 'Yes' : 'No'}`"></v-switch></div>
                  <div>The child support is paid to
                    <v-select
                      :items="['Personal Account', 'Child Support', 'Third Party']"
                      v-model="product.data.childSupportPaidTo"
                      label="Select Account"
                      class="inline ml-2"
                    ></v-select></div>
                    <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col id="parenting-concerns" cols="12">
                  <div class="headline">Parenting concerns with other person</div>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="concernsHeaders"
                    :items="product.data.concerns"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                  <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td><v-text-field v-model="item.dateRange" type="text" persistent-hint hint="eg. Jan 2018/Jun 2018"></v-text-field></td>
                          <td><v-text-field v-model="item.details" type="text"></v-text-field></td>
                          <td><v-btn color="error" outlined @click="product.data.concerns.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                    </tbody>
                  </template>
                    <template v-slot:footer>
                      <td :colspan="concernsHeaders.length">
                        <v-btn dark color="teal" @click="product.data.concerns.push({})">Add Concern +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col id="family-dispute" cols="12">
                  <div class="headline">Family dispute resolution</div>
                  <div>Has family dispute resolution been attended? <v-switch class="inline ml-2" v-model="product.data.familyDisputeAttended" :label="`${product.data.familyDisputeAttended ? 'Yes' : 'No'}`"></v-switch></div>
                  <div>If yes, Date of attendance:
                    <v-menu
                      v-model="product.data.menuDisputeAttendanceDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      class="inline"
                      min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="product.data.disputeAttendanceDate | formatDatePicker"
                        label="Attendance Date"
                        readonly
                        class="inline ml-2"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="product.data.disputeAttendanceDate"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                    ></v-date-picker>
                    </v-menu>, with <v-text-field class="inline" v-model="product.data.disputeMediatorName" type="text" label="Mediator Name"></v-text-field>
                  </div>
                  <div>Did you receive a section 601A? <v-switch class="inline ml-2" v-model="product.data.receivedSection601A" :label="`${product.data.receivedSection601A ? 'Yes' : 'No'}`"></v-switch></div>
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col id="post-separation" cols="12">
                  <div class="headline">Post separation parenting course</div>
                  <div>Have you attended any post separation parenting courses? <v-switch class="inline ml-2" v-model="product.data.attendedPostSeparationCourse" :label="`${product.data.attendedPostSeparationCourse ? 'Yes' : 'No'}`"></v-switch></div>
                  <div>If yes, please supply the date, name of course and certificate of attendance:</div>
                  <div><v-text-field v-model="product.data.postSeparationCourseDetails" type="text" label="Course Details"></v-text-field></div>
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col id="parenting-arrangements" cols="12">
                  <div class="headline">Current parenting arrangements</div>
                  <div><v-textarea v-model="product.data.currentChallenges" label="Current challenges with arrangement"></v-textarea></div>
                  <div><v-textarea v-model="product.data.currentBenefits" label="Current benefits with arrangement"></v-textarea></div>
                  <div><v-textarea v-model="product.data.specificRequirements" label="Specific requirements for decisions"></v-textarea></div>
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col id="proposed-parenting-orders" cols="12">
                  <div class="headline">Describe your proposed parenting orders</div>
                  <div><v-textarea v-model="product.data.proposedParentingOrders" label="Your proposed parenting orders"></v-textarea></div>
                  <v-divider class="ma-2"></v-divider>
                </v-col>
                <v-col id="expartner-parenting-orders" cols="12">
                  <div class="headline">What do you think your ex-partner would like as parenting orders</div>
                  <div><v-textarea v-model="product.data.partnerParentingOrders" label="Ex-partner parenting orders"></v-textarea></div>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="2" :transition="false" :reverse-transition="false">
              <v-card class="index-card">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div>Sections</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <div><a href='#top'>Top of page</a></div>
                        <div><a href='#financial-costs'>Financial costs</a></div>
                        <div><a href='#financial-income'>Financial income</a></div>
                        <div><a href='#loans'>Loans</a></div>
                        <div><a href='#outcome'>Desired Outcome</a></div>
                        <div><a href='#expartner-outcome'>Ex-Partner Outcome</a></div>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
              <v-row justify="start">
                <v-col cols="12" id="financial-costs">
                  <div class="headline">Distribution of expenses</div>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="financialCostHeaders"
                    :items="product.data.financialCosts"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer>
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td>
                            <v-text-field v-if="item.editable" v-model="item.name" type="text"></v-text-field>
                            <span v-else>{{ item.name }}</span></td>
                          <td><v-text-field v-model="item.personA" type="number" suffix="%"></v-text-field></td>
                          <td><v-text-field v-model="item.personB" type="number" suffix="%"></v-text-field></td>
                          <td><v-text-field v-model="item.jointAccount" type="number" suffix="%"></v-text-field></td>
                          <td><v-btn v-if="item.editable" color="error" outlined @click="product.data.financialCosts.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="financialCostHeaders.length">
                        <v-btn dark color="teal" @click="product.data.financialCosts.push({editable: true})">Add Cost +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                  <v-divider class="ma-2"></v-divider>
                </v-col>
                <v-col cols="12" id="financial-costs">
                  <div class="headline">Distribution of income</div>
                </v-col>
                <v-col cols="12" id="financial-income">
                  <v-data-table
                    :headers="financialIncomeHeaders"
                    :items="product.data.financialIncome"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td>
                            <v-text-field v-if="item.editable" v-model="item.name" type="text"></v-text-field>
                            <span v-else>{{ item.name }}</span></td>
                          <td><v-text-field v-model="item.personA" type="number" suffix="%"></v-text-field></td>
                          <td><v-text-field v-model="item.personB" type="number" suffix="%"></v-text-field></td>
                          <td><v-text-field v-model="item.jointAccount" type="number" suffix="%"></v-text-field></td>
                          <td><v-btn v-if="item.editable" color="error" outlined @click="product.data.financialIncome.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="financialIncomeHeaders.length">
                        <v-btn dark color="teal" @click="product.data.financialIncome.push({editable: true})">Add Income +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
                <hr class="ma-2"/>
                <v-col cols="12" id="loans">
                  <div class="headline">Financial loans/debt during relationship</div>
                  <p>Include known debts from when you first met, during relationship, during marriage and post separation. The ownership of the debt could be person A, Person B or joint</p>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="deptHeaders"
                    :items="product.data.debt"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td>
                            <v-menu
                                v-model="item.menuDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="item.date | formatDatePicker"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="item.date"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                              ></v-date-picker>
                              </v-menu>
                          </td>
                          <td><v-text-field v-model="item.loanFrom" type="text"></v-text-field></td>
                          <td><v-text-field v-model="item.owner" type="text"></v-text-field></td>
                          <td><v-text-field prefix="$" v-model="item.amount" type="number"></v-text-field></td>
                          <td><v-text-field v-model="item.reason" type="text"></v-text-field></td>
                          <td><v-btn color="error" outlined @click="product.data.debt.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="deptHeaders.length">
                        <v-btn dark color="teal" @click="product.data.debt.push({})">Add Debt +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" id="outcome">
                  <v-textarea
                    v-model="product.data.financialOutcome"
                    label="What do you want as financial outcomes of the divorce?"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" id="expartner-outcome">
                  <v-textarea
                    v-model="product.data.exPartnerFinancialOutcome"
                    label="What would your ex-partner expect or want as a financial outcome of the divorce?"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="3" :transition="false" :reverse-transition="false">
              <v-card class="index-card">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div>Sections</div>
                      </template>
                      <v-card-text>
                        <div><a href='#top'>Top of page</a></div>
                        <div><a href='#medical-history'>Medical History</a></div>
                        <div><a href='#mental-health'>Mental Health History</a></div>
                        <div><a href='#violence-history'>Domestic Violence</a></div>
                        <div><a href='#substance-abuse'>Substance Abuse</a></div>
                        <div><a href='#gambling'>Gambling</a></div>
                        <div><a href='#infidelity'>Infidelity</a></div>
                        <div><a href='#questions'>Questions for lawyer</a></div>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
              <v-row justify="start">
                <v-col cols="12" id="medical-history">
                  <div class="headline">Person A's medical history</div>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="medicalHistoryHeaders"
                    :items="product.data.medicalPersonA"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                  <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td>
                            <v-menu
                                v-model="item.menuDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="item.date | formatDatePicker"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="item.date"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                              ></v-date-picker>
                              </v-menu>
                          </td>
                          <td><v-text-field v-model="item.concern" type="text"></v-text-field></td>
                          <td><v-text-field v-model="item.DrOrFacility" type="text"></v-text-field></td>
                          <td><v-text-field v-model="item.details" type="text"></v-text-field></td>
                          <td><v-btn color="error" outlined @click="product.data.medicalPersonA.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="medicalHistoryHeaders.length">
                        <v-btn dark color="teal" @click="product.data.medicalPersonA.push({})">Add +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12">
                  <div class="headline">Person B's medical history</div>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="medicalHistoryHeaders"
                    :items="product.data.medicalPersonB"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="(item, index) in items" :key="index">
                        <td>
                          <v-menu
                              v-model="item.menuDate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :value="item.date | formatDatePicker"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="item.date"
                              :max="new Date().toISOString().substr(0, 10)"
                              min="1950-01-01"
                            ></v-date-picker>
                            </v-menu>
                        </td>
                        <td><v-text-field v-model="item.concern" type="text"></v-text-field></td>
                        <td><v-text-field v-model="item.DrOrFacility" type="text"></v-text-field></td>
                        <td><v-text-field v-model="item.details" type="text"></v-text-field></td>
                        <td><v-btn color="error" outlined @click="product.data.medicalPersonB.splice(index, 1)">Remove</v-btn></td>
                      </tr>
                    </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="medicalHistoryHeaders.length">
                        <v-btn dark color="teal" @click="product.data.medicalPersonB.push({})">Add +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" id="mental-health">
                  <div class="headline">History of mental health</div>
                  <p>Note personality disorders, chemical disorders as well as general counselling</p>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="mentalHealthHistoryHeaders"
                    :items="product.data.mentalHealthHistory"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td><v-text-field v-model="item.forPerson" type="text"></v-text-field></td>
                          <td>
                            <v-menu
                                v-model="item.menuDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="item.date | formatDatePicker"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="item.date"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                              ></v-date-picker>
                              </v-menu>
                          </td>
                          <td><v-text-field v-model="item.concern" type="text"></v-text-field></td>
                          <td><v-text-field v-model="item.DrOrFacility" type="text"></v-text-field></td>
                          <td><v-text-field v-model="item.details" type="text"></v-text-field></td>
                          <td><v-btn color="error" outlined @click="product.data.mentalHealthHistory.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="mentalHealthHistoryHeaders.length">
                        <v-btn dark color="teal" @click="product.data.mentalHealthHistory.push({})">Add +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                  <v-textarea
                    v-model="product.data.mentalHealthComment"
                    label="Other comments"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" id="violence-history">
                  <div class="headline">History of violence/domestic abuse/threats/stalking/intimidation</div>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="domesticViolenceHistoryHeaders"
                    :items="product.data.domesticViolenceHistory"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td><v-text-field v-model="item.forPerson" type="text"></v-text-field></td>
                          <td>
                            <v-menu
                                v-model="item.menuDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="item.date | formatDatePicker"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="item.date"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                              ></v-date-picker>
                              </v-menu>
                          </td>
                          <td><v-text-field v-model="item.concern" type="text"></v-text-field></td>
                          <td><v-text-field v-model="item.details" type="text"></v-text-field></td>
                          <td><v-btn color="error" outlined @click="product.data.domesticViolenceHistory.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="domesticViolenceHistoryHeaders.length">
                        <v-btn dark color="teal" @click="product.data.domesticViolenceHistory.push({})">Add +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                  <v-textarea
                    v-model="product.data.domesticViolenceComment"
                    label="Other comments"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" id="substance-abuse">
                  <div class="headline">History of substance abuse</div>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="domesticViolenceHistoryHeaders"
                    :items="product.data.substanceAbuseHistory"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td><v-text-field v-model="item.forPerson" type="text"></v-text-field></td>
                          <td>
                            <v-menu
                                v-model="item.menuDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="item.date | formatDatePicker"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="item.date"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                              ></v-date-picker>
                              </v-menu>
                          </td>
                          <td><v-text-field v-model="item.concern" type="text"></v-text-field></td>
                          <td><v-text-field v-model="item.details" type="text"></v-text-field></td>
                          <td><v-btn color="error" outlined @click="product.data.substanceAbuseHistory.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="domesticViolenceHistoryHeaders.length">
                        <v-btn dark color="teal" @click="product.data.substanceAbuseHistory.push({})">Add +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                  <v-textarea
                    v-model="product.data.substanceAbuseComment"
                    label="Other comments"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" id="gambling">
                  <div class="headline">History of gambling</div>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="gamblingHistoryHeaders"
                    :items="product.data.gamblingHistory"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                          <td><v-text-field v-model="item.forPerson" type="text"></v-text-field></td>
                          <td>
                            <v-menu
                                v-model="item.menuDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  :value="item.date | formatDatePicker"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="item.date"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                              ></v-date-picker>
                              </v-menu>
                          </td>
                          <td><v-text-field v-model="item.details" type="text"></v-text-field></td>
                          <td><v-btn color="error" outlined @click="product.data.gamblingHistory.splice(index, 1)">Remove</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="gamblingHistoryHeaders.length">
                        <v-btn dark color="teal" @click="product.data.gamblingHistory.push({})">Add +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                  <v-textarea
                    v-model="product.data.gamblingComment"
                    label="Other comments"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12" id="infidelity">
                  <div class="headline">History of infidelity</div>
                  <p>Note personality disorders, chemical disorders as well as general counselling</p>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="infidelityHistoryHeaders"
                    :items="product.data.infidelityHistory"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="(item, index) in items" :key="index">
                        <td><v-text-field v-model="item.forPerson" type="text"></v-text-field></td>
                        <td>
                          <v-menu
                              v-model="item.menuDate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :value="item.date | formatDatePicker"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="item.date"
                              :max="new Date().toISOString().substr(0, 10)"
                              min="1950-01-01"
                            ></v-date-picker>
                            </v-menu>
                        </td>
                        <td><v-text-field v-model="item.duration" type="text"></v-text-field></td>
                        <td><v-text-field v-model="item.details" type="text"></v-text-field></td>
                        <td><v-btn color="error" outlined @click="product.data.infidelityHistory.splice(index, 1)">Remove</v-btn></td>
                      </tr>
                    </tbody>
                    </template>
                    <template v-slot:footer>
                      <td :colspan="infidelityHistoryHeaders.length">
                        <v-btn dark color="teal" @click="product.data.infidelityHistory.push({})">Add +</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                  <v-textarea
                    v-model="product.data.infidelityComment"
                    label="Other comments"
                  ></v-textarea>
                </v-col>
                <v-col>
                  <div class="headline">What other general outcomes would you like?</div>
                  <v-textarea
                    v-model="product.data.generalOutcomes"
                    label="Other General Outcomes"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col cols="12">
                  <div class="headline">For your first lawyer's appointment, take with you:</div>
                  <ul>
                    <li>Draft separation statement</li>
                    <li>Birth certificates/passports for you and children (copy)</li>
                    <li>Marriage certificate (copy)</li>
                    <li>Financial statements (copies)</li>
                    <li>Other relevant certificates - Section 60i, post-separation parenting course, other</li>
                    <li>Any current orders or agreements between PERSON A and B.</li>
                  </ul>
                </v-col>
                <v-col cols="12" id="questions">
                  <div class="headline">Questions to discuss with your lawyer:</div>
                </v-col>
              </v-row>
                <template v-for="(question, index) in product.data.lawyerQuestions">
                  <v-row :key="index">
                    <v-col cols="10">
                      <v-text-field class="mb-2" label="Question" v-model="question.value"></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn color="error" outlined @click="product.data.lawyerQuestions.splice(index, 1)">Remove</v-btn>
                    </v-col>
                  </v-row>
                </template>
                <v-row>
                  <v-col cols="12">
                    <v-btn dark color="teal" @click="product.data.lawyerQuestions.push({})">Add Question +</v-btn>
                  </v-col>
                </v-row>
            </v-tab-item>
          </v-tabs>
        </div>
    </v-row>
    <product-purchase-dialog
      :dialogVisible="dialogVisible"
      :test="product.test"
      :firstName="firstName"
      :lastName="lastName"
      :email="email"
      :productName="product.name"
      :amount="product.cost"
      :stripePriceId="product.stripePriceId"
      @input="didDismissDialog"
      :didCompletePurchase="didCompletePurchase"></product-purchase-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    productId: 'be7137bd-5ec7-4f89-a474-5ae2afb03836',
    modal: false,
    activeTab: null,
    switch1: true,
    switch2: false,
    dialogVisible: false,
    productImageURL: '',
    downloadURL: '',
    selection: '',
    rules: {
      required: v => !!v || 'Required.'
    },
    choresHeaders: [
      { text: 'Activity', align: 'left', sortable: false },
      { text: 'Person A %', value: 'personA', sortable: false },
      { text: 'Person B %', value: 'personB', sortable: false }
    ],
    concernsHeaders: [
      { text: 'Date Range', align: 'left', sortable: false },
      { text: 'Details', align: 'left', sortable: false }
    ],
    financialCostHeaders: [
      { text: 'Cost', align: 'left', sortable: false },
      { text: 'Person A %', align: 'left', sortable: false },
      { text: 'Person B %', align: 'left', sortable: false },
      { text: 'Joint Account', align: 'left', sortable: false }
    ],
    financialIncomeHeaders: [
      { text: 'Income Deposited', align: 'left', sortable: false },
      { text: 'Person A %', align: 'left', sortable: false },
      { text: 'Person B %', align: 'left', sortable: false },
      { text: 'Joint Account', align: 'left', sortable: false }
    ],
    deptHeaders: [
      { text: 'Date', align: 'left', sortable: false },
      { text: 'Loan from', align: 'left', sortable: false },
      { text: 'Ownership of debt', align: 'left', sortable: false },
      { text: 'Amount', align: 'left', sortable: false },
      { text: 'Reason of debt', align: 'left', sortable: false }
    ],
    medicalHistoryHeaders: [
      { text: 'Date', align: 'left', sortable: false },
      { text: 'Concern', align: 'left', sortable: false },
      { text: 'Treating Dr Or Facility', align: 'left', sortable: false },
      { text: 'Details And Duration', align: 'left', sortable: false }
    ],
    mentalHealthHistoryHeaders: [
      { text: 'For Person A/B', align: 'left', sortable: false },
      { text: 'Date', align: 'left', sortable: false },
      { text: 'Concern', align: 'left', sortable: false },
      { text: 'Treating Dr Or Facility', align: 'left', sortable: false },
      { text: 'Details And Duration', align: 'left', sortable: false }
    ],
    domesticViolenceHistoryHeaders: [
      { text: 'By Person A/B', align: 'left', sortable: false },
      { text: 'Date', align: 'left', sortable: false },
      { text: 'Concern', align: 'left', sortable: false },
      { text: 'Details And Duration', align: 'left', sortable: false }
    ],
    gamblingHistoryHeaders: [
      { text: 'By Person A/B', align: 'left', sortable: false },
      { text: 'Date', align: 'left', sortable: false },
      { text: 'Details And Duration', align: 'left', sortable: false }
    ],
    infidelityHistoryHeaders: [
      { text: 'By Person A/B', align: 'left', sortable: false },
      { text: 'Date', align: 'left', sortable: false },
      { text: 'Duration', align: 'left', sortable: false },
      { text: 'Details And Duration', align: 'left', sortable: false }
    ]
  }),
  created () {
    this.$store.dispatch('products/view', this.productId)
  },
  computed: {
    product () {
      return this.$store.getters['products/loadedProduct']
    },
    loading () {
      return this.$store.getters.loading
    },
    isSaving () {
      return this.$store.getters['products/isSaving']
    },
    isExportingPdf () {
      return this.$store.getters['products/isExportingPdf']
    },
    firstName () {
      return this.$store.getters.user.firstName
    },
    lastName () {
      return this.$store.getters.user.lastName
    },
    email () {
      return this.$store.getters.user.email
    }
  },
  watch: {
    // menu (val) {
    //   val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    // }
  },
  methods: {
    save () {
      this.$store.dispatch('products/save')
    },
    showAlert () {
      this.dialogVisible = true
    },
    didDismissDialog (value) {
      this.dialogVisible = false
    },
    didCompletePurchase (productId) {
      this.$store.dispatch('products/unlock', this.productId)
    },
    exportPDF () {
      this.$store.dispatch('products/exportPDF')
    }
  }
}
</script>

<style scoped>
.main-layout {
  margin-top: 64px;
}
.index-card {
  position: fixed;
  right: 0;
  top: 140px;
  right: 24px;
  z-index: 1;
}
</style>
